<div class="flex h-full flex-col">
  <div class="shrink-0 border-x-0 border-y-0 border-b border-solid border-pill px-6 py-2.5">
    <app-dialog-header
      [flush]="true"
      titleId="profile-settings-title"
      [title]="currentSection.name | translate"
      [closeLabel]="'General.Close' | translate"
      (closed)="close()"
    >
      <!-- [value] alone cannot undo a click the unsaved-changes prompt then cancels: the group has
           already moved and the bound value never changed. onNavigateTo puts it back. -->
      <mat-button-toggle-group
        #sectionToggle="matButtonToggleGroup"
        dialogHeaderLead
        class="tl-segmented"
        [value]="navigateTo"
        (change)="onNavigateTo($event.value, sectionToggle)"
        [attr.aria-label]="'Settings.ProfileType' | translate"
      >
        <mat-button-toggle *ngFor="let nav of navigation" [value]="nav.id">
          <span class="flex items-center gap-1.5">
            <mat-icon class="tl-icon-sm">{{ nav.icon }}</mat-icon>
            {{ nav.shortName | translate }}
          </span>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </app-dialog-header>
  </div>

  <div class="min-h-0 flex-1 overflow-hidden">
    <app-tank-profile-settings *ngIf="navigateTo === '1'" #tankProfiles></app-tank-profile-settings>
    <app-filter-profile-settings *ngIf="navigateTo === '2'" #filterProfiles></app-filter-profile-settings>
  </div>
</div>
